import { Hero } from "@/components/home/Hero";
import { BrandMarquee } from "@/components/home/BrandMarquee";
import { LiveDashboard } from "@/components/home/LiveDashboard";
import { AboutCards } from "@/components/home/AboutCards";
import { NftHero } from "@/components/home/NftHero";
import { Benefits } from "@/components/home/Benefits";
import { EcosystemSection } from "@/components/home/EcosystemSection";
import { RoadmapTimeline } from "@/components/home/RoadmapTimeline";
import { Community } from "@/components/home/Community";

export default function Home() {
  return (
    <>
      <Hero />
      <BrandMarquee />
      <LiveDashboard />
      <AboutCards />
      <NftHero />
      <Benefits />
      <EcosystemSection />
      <RoadmapTimeline />
      <Community />
    </>
  );
}
